import type Appointment from '@spike/appointment-model';
import type { BoardingOffer } from 'model/Service';
import { isBoardingDealOfferType } from 'components/CreateBooking/Boarding/utils/boardingDealOffers';

type AppointmentDetailsBoarding = {
    boarding?: { selectedOffer?: BoardingOffer };
};

export const BOARDING_DEAL_MEMBERSHIP_TOOLTIP =
    'Membership cannot be assigned because this booking has an associated deal.';

export function appointmentHasBoardingDeal(appointment: Appointment): boolean {
    const details = appointment.details as AppointmentDetailsBoarding | undefined;
    const offer = details?.boarding?.selectedOffer;
    return offer != null && isBoardingDealOfferType(offer);
}
